import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GET_KNOWLEDGE,
  POST_WEBSITE_KNOWLEDGE,
} from "../api/aiKnowledge.service";

const initialState = {
  knowledge: [],
  lastUploaded: null,
  loading: false,
  error: null,
};

export const getKnowledge = createAsyncThunk(
  "aiKnowledge/getKnowledge",
  async (_, thunkAPI) => {
    try {
      const resp = await GET_KNOWLEDGE();
      return resp;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const uploadWebsiteKnowledge = createAsyncThunk(
  "aiKnowledge/uploadWebsiteKnowledge",
  async ({ KnowledgeUrl, agentId, sourceName }, thunkAPI) => {
    try {
      const resp = await POST_WEBSITE_KNOWLEDGE({
        KnowledgeUrl,
        agentId,
        sourceName,
      });
      return resp;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const aiKnowledgeSlice = createSlice({
  name: "aiKnowledge",
  initialState,
  reducers: {
    resetKnowledgeError(state) {
      state.error = null;
    },
    clearKnowledgeState(state) {
      state.knowledge = [];
      state.lastUploaded = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getKnowledge.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getKnowledge.fulfilled, (state, action) => {
      state.loading = false;
      state.knowledge = action.payload;
    });
    builder.addCase(getKnowledge.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error.message;
    });

    builder.addCase(uploadWebsiteKnowledge.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(uploadWebsiteKnowledge.fulfilled, (state, action) => {
      state.loading = false;
      state.lastUploaded = action.payload;
    });
    builder.addCase(uploadWebsiteKnowledge.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error.message;
    });

  },
});

export const { resetKnowledgeError, clearKnowledgeState } =
  aiKnowledgeSlice.actions;
export default aiKnowledgeSlice.reducer;
